export function setInLocalStorage(key: string, value: string) {
  const myPartitionKey = Office.context?.partitionKey;

  // Check if local storage is partitioned.
  // If so, use the partition to ensure the data is only accessible by your add-in.
  if (myPartitionKey) {
    localStorage.setItem(myPartitionKey + "_" + key, value);
  } else {
    localStorage.setItem(key, value);
  }
}

export function getFromLocalStorage(key: string) {
  const myPartitionKey = Office.context?.partitionKey;

  // Check if local storage is partitioned.
  if (myPartitionKey) {
    return localStorage.getItem(myPartitionKey + "_" + key);
  } else {
    const value = localStorage.getItem(key);
    return localStorage.getItem(key);
  }
}

export function removeFromLocalStorage(key: string) {
  const myPartitionKey = Office.context?.partitionKey;

  // Check if local storage is partitioned.
  if (myPartitionKey) {
    localStorage.removeItem(myPartitionKey + "_" + key);
  } else {
    localStorage.removeItem(key);
  }
}
